import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

/**
 * Interface for confirm email payload
 */
export interface ConfirmEmailPayload {
  email: string;
  token: string;
}

/**
 * Interface for confirm email response
 */
export interface ConfirmEmailResponse {
  message: string;
  data: {
    id: number;
    email: string;
    phone_number: string | null;
    first_name: string | null;
    last_name: string | null;
    date_joined: string;
    country_code: string;
    date_of_birth: string | null;
    display_photo: string | null;
    country: string;
    address: string | null;
    user_type: string;
    objective: string;
    role: string;
    referral: string;
    company_info: any | null;
    onboarded: boolean;
  };
}

/**
 * Hook for confirming email using TanStack React Query
 */
export const useConfirmEmail = () => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async (payload: ConfirmEmailPayload) => {
      const response = await apiClient.post<ConfirmEmailResponse>('/auth/confirm-email/', payload);
      return response.data;
    },
    onError: (err: any) => {
      console.error('Confirm Email Error:', err);
      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error?.message ||
        'Failed to verify your email address, please try again later and contact support if the error persists.';
      openToast({
        show: true,
        heading: 'Sorry',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};
